"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _Button = require("../Button");
var _Box = _interopRequireDefault(require("../Box"));
var _ListActionButton = _interopRequireDefault(require("./ListActionButton/ListActionButton"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var List = exports.List = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var actionButtonProps = _ref.actionButtonProps,
    a11yProps = _ref.a11yProps,
    children = _ref.children,
    className = _ref.className;
  var a11yListProps = a11yProps || {};
  return /*#__PURE__*/_react["default"].createElement(_List["default"], _extends({
    ref: ref,
    className: className
  }, a11yListProps), children, actionButtonProps && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    pt: 2,
    px: 2,
    pb: 1
  }, /*#__PURE__*/_react["default"].createElement(_ListActionButton["default"], {
    fullWidth: actionButtonProps.fullWidth,
    onClick: actionButtonProps.onClick,
    size: "small",
    variant: actionButtonProps.variant
  }, actionButtonProps.children)));
});
List.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  actionButtonProps: _propTypes["default"].shape({
    children: _propTypes["default"].node,
    fullWidth: _propTypes["default"].bool,
    onClick: _propTypes["default"].func,
    variant: _propTypes["default"].oneOf(Object.values(_Button.Variant))
  }),
  a11yProps: _propTypes["default"].object,
  className: _propTypes["default"].string
} : {};